<template>
  <tr v-if="Object.keys(filters).length > 0" class="report-filter-row grey lighten-3">
    <td
      v-for="header in headers"
      :key="header.text"
    >
      <v-select
        v-if="filters.hasOwnProperty(header.value) && filters[header.value].type === 'select'"
        hide-details
        dense
        small
        multiple
        clearable
        persistent-hint
        single-line
        class="data-table-finance-filter-select"
        :items="getSelectOptionsWithSort(filters[header.value].values || columnValueList(header.value), header.value)"
        :style="{width: (filters[header.value] || {width: false}).width}"
        :value="filters[header.value].data"
        @input="updateFilter(header.value, $event)"
      >
        <template #append-outer>
          <v-btn-toggle
            v-if="filters[header.value]?.sortable"
            v-model="selectOptionsSortDirectionMap[header.value]"
            class="direction-filter-toggle"
          >
            <v-btn
              class="pa-1"
              plain
              small
              solo
              value="asc"
            >
              ↑
            </v-btn>
            <v-btn
              class="pa-1"
              plain
              small
              solo
              value="desc"
            >
              ↓
            </v-btn>
          </v-btn-toggle>
        </template>
      </v-select>
      <v-text-field
        class="data-table-finance-filter-textfield"
        v-if="filters.hasOwnProperty(header.value) && filters[header.value].type === 'text'"
        v-model="filters[header.value].data"
        :style="{width: (filters[header.value] || {width: false}).width}"
        hide-details
        @input="updateFilter(header.value, $event)"
      ></v-text-field>
    </td>
  </tr>
</template>

<script>
  export default {
    props: {
      filters: Object,
      headers: Array,
      columnValueList: Function,
      value: Object,
    },
    data() {
      return {
        selectOptionsSortDirectionMap: this.getSortMap(this.headers, this.filters),
      }
    },

    methods: {

      updateFilter (filterKey, event) {
        this.$set(this.filters, filterKey, { ...this.filters[filterKey], data: event })
        this.$emit('input', this.filters)
      },

      getSortMap(headers, filters) {
        return Object.fromEntries(
          headers.filter(header => filters[header.value]?.type === 'select').map(header => [header.value, null])
        )
      },

      getSelectOptionsWithSort(items, headerValue) {
        const sortDirection = this.selectOptionsSortDirectionMap[headerValue]

        switch (sortDirection) {
          case 'asc':
            return items.sort()
          case 'desc':
            return items.sort().reverse()
          default:
            return items
        }
      },
    },

    watch: {
      headers: {
        immediate: true,
        handler(newHeaders) {
          this.selectOptionsSortDirectionMap = this.getSortMap(newHeaders, this.filters)
        }
      }
    },
  }
</script>

<style lang="scss" scoped>
  @import '@/assets/table/report-table.scss';

  .direction-filter-toggle {
    .v-btn {
      min-width: unset;
      height: unset;
    }
  }
</style>
